export type UiContentMode = 'standard' | 'compact';
export type ServerContentMode = 'STANDARD' | 'COMPACT';

export type ContentStatus = 'DRAFT' | 'CURRENT';
export type QueryContentStatus = 'draft' | 'current' | 'archived';

/**
 * Convert a server-reported content mode to the UI representation.
 * Defaults to "standard" for unknown or missing values.
 */
export const serverToUiContentMode = (server?: unknown): UiContentMode => {
	if (typeof server === 'string') {
		const v = server.toLowerCase();
		if (v === 'compact') return 'compact';
	}
	return 'standard';
};

/**
 * Convert a UI-selected content mode to the server value.
 */
export const uiToServerContentMode = (ui: UiContentMode): ServerContentMode =>
	ui === 'compact' ? 'COMPACT' : 'STANDARD';

/**
 * Toggle between compact and standard UI modes.
 */
export const flipContentMode = (m: UiContentMode): UiContentMode =>
	m === 'compact' ? 'standard' : 'compact';

/**
 * Resolve content status (DRAFT/CURRENT) based on page context.
 */
export const resolveContentStatus = (opts: {
	isLivePage: boolean;
	isEditorPage: boolean;
}): ContentStatus => {
	if (opts.isLivePage) return 'CURRENT';
	if (opts.isEditorPage) return 'DRAFT';
	return 'CURRENT';
};

/**
 * Map a "draftness" boolean to the content query status.
 */
export const queryStatusFor = (isDraft: boolean, isArchived?: boolean): QueryContentStatus => {
	return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
